import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { SubSink } from "subsink";
import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { StringHelper } from "../../../utilities/contracts/string-helper";
import { DynamicControlDirective } from "../../dynamic-control-component.model";
import { FormService } from "../../form.service";
import { SelectableInput } from "../selectable-input.model";
import { SwitchGroupSampling } from "./switch-group-sampling.model";

@Component({
  selector: "form-switch-group-sampling",
  templateUrl: "./switch-group-sampling.component.html",
  styleUrls: ["./switch-group-sampling.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchGroupSamplingComponent
  extends DynamicControlDirective<SwitchGroupSampling>
  implements OnInit, OnDestroy, AfterViewInit {
  label = "";
  private sink = new SubSink();
  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly formService: FormService
  ) {
    super();
  }

  ngOnInit(): void {
    this.sink.add(
      this.control.statusChanges.subscribe(() =>
        this.formService.updateDom.next()
      ),
      this.formService.updateDom.subscribe(() =>
        this.changeDetector.markForCheck()
      )
    );
    this.label = StringHelper.toTitleCase(this.model.label);
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.sink.unsubscribe();
  }

  get hasLabel(): boolean {
    return StringHelper.isAvailable(this.model.label);
  }

  get options(): SelectableInput[] {
    return this.model.items || [];
  }

  get hasOptions(): boolean {
    return ArrayHelper.isAvailable(this.options);
  }

  get classes(): string {
    return this.getClasses("switch");
  }
}
